import { guardArray } from "../array";
import type { SubstitutionPlanFrontendFormSchema } from "../schemas";
import type { Nullable } from "../types";

type Items = Array<Partial<SubstitutionPlanFrontendFormSchema["items"][number]>>;
type Item = Items[number];
export type SubstitutionPlanValidation = ReturnType<typeof validateSubstitutionPlan>;

/**
 * This function is used to validate a substitution plan based on the following constraints:
 * - item is set "not required" or has >1 substitutions
 * @param items
 * @param invalidItemCallback
 */
export function validateSubstitutionPlan(
	items: Nullable<Items>,
	invalidItemCallback?: (item: Item) => void,
) {
	const invalidItems: Items = [];

	for (const item of guardArray(items)) {
		const isValid = validateSubstitutionPlanItem(item);
		if (isValid) continue;
		invalidItems.push(item);
	}

	const isInvalid = invalidItems.length > 0 && guardArray(items).length > 0;
	const isValid = !isInvalid;

	if (invalidItemCallback) {
		for (const invalidItem of invalidItems) {
			invalidItemCallback(invalidItem);
		}
	}

	const invalidItemsLength = invalidItems.length;

	return { isInvalid, isValid, invalidItems, invalidItemsLength };
}

export function validateSubstitutionPlanItem(item: Item) {
	if (item.isAssignmentNotRequired) return true;
	if (guardArray(item.assignedUserIds).length > 0) return true;
	return false;
}
